import { Progress } from '@base-ui/react/progress'
import { type ReactNode, useId } from 'react'
import { cx } from '../cx'
import styles from './ProgressBar.module.css'

export function ProgressBar({
  value,
  max = 100,
  label,
  valueLabel,
  tone = 'accent',
  message,
  className,
}: {
  value: number
  max?: number
  label: string
  valueLabel?: string
  tone?: 'accent' | 'warning' | 'danger'
  message?: ReactNode
  className?: string
}) {
  const messageId = useId()
  return (
    <Progress.Root
      value={value}
      max={max}
      getAriaValueText={valueLabel ? () => valueLabel : undefined}
      aria-describedby={message ? messageId : undefined}
      className={cx(styles.root, className)}
      data-tone={tone}
    >
      <div className={styles.head}>
        <Progress.Label>{label}</Progress.Label>
        <Progress.Value className={styles.value}>
          {(formatted) => valueLabel ?? formatted}
        </Progress.Value>
      </div>
      <Progress.Track className={styles.track}>
        <Progress.Indicator className={styles.fill} />
      </Progress.Track>
      {message && (
        <p id={messageId} className={styles.message}>
          {message}
        </p>
      )}
    </Progress.Root>
  )
}
